// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cropper-wrapper[data-v-6e4b1ea8] {\n  width: 500px;\n  height: 500px;\n}", ""]);
// Exports
module.exports = exports;
